import { render } from "./AllDepartmentUserDataTable.vue?vue&type=template&id=144f0710&scoped=true"
import script from "./AllDepartmentUserDataTable.vue?vue&type=script&lang=js"
export * from "./AllDepartmentUserDataTable.vue?vue&type=script&lang=js"

import "./AllDepartmentUserDataTable.vue?vue&type=style&index=0&id=144f0710&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144f0710"]])

export default __exports__